// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__RgBYj","loading":"styles_loading__8PaKt"};